<template>
  <b-col class="c307">
    <b-row>

      <b-col lg="5" class="p-0 m-0 ">
        <img :src="image" :alt="alt" class="c307-image p-0 w-100 m-0">
      </b-col>
      <b-col lg="7" class="">
        <div class="">
          <slot name="p-1"/>
        </div>
        <div class="position-absolute w-100 c307-bottom-text-section">
          <slot name="p-2"/>
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
export default {
  name: "C306",
  props: {
    image: {
      default: 'https://picsum.photos/200/300'
    },
    alt: {
      default: 'mix it web'
    }
  }
}
</script>

<style scoped>
.c307-image {
  object-fit: cover;
  height: 250px;
}

.c307-bottom-text-section {
  bottom: 0;
}
</style>